import React, { PureComponent } from "react";
import i18n from 'i18next'

class FaqItem extends PureComponent {
  render() {
    const { item, id, index } = this.props
    return <div className="row">
      <div className="col-md-8 offset-md-2">
        <a className="question" data-toggle="collapse" href={`#${id}` + index + 1} role="button" data-target={`#${id}` + index + 1} aria-expanded="false" aria-controls="collapseOne">
          <span className="question-text">
            <b>Q{index + 1}:</b>
            {i18n.t(item.question)}
          </span>
        </a>
        <div id={id + index + 1} className="collapse card-body" aria-labelledby="headingOne" data-parent="#faq">
          {
            Array.isArray(item.answer)
            ? item.answer.map(answer => <p className="desc" key={answer} dangerouslySetInnerHTML={{ __html: i18n.t(answer) }}></p>)
            : <p className="desc" dangerouslySetInnerHTML={{ __html: i18n.t(item.answer) }}></p>
          }
        </div>
      </div>
    </div >
  }
}

class Faq extends PureComponent {
  render() {
    const msg = this.props.Message;
    return (
      <section id="faq">
        <div className="container">
          <div className="title-block">
            <h2>{i18n.t(msg.faq)}</h2>
          </div>
          <h4 className="col-md-8 offset-md-2"><img className="faq-icon" src="images/faqup.png" alt="faq icon" />{i18n.t(msg.faqTitle01)}</h4>
          {
            msg.faqData01.map((item, index) => {
              return <FaqItem key={index} item={item} id="faq-a" index={index} />
            })
          }
          <h4 className="col-md-8 offset-md-2"><img className="faq-icon" src="images/faqup.png" alt="faq icon" />{i18n.t(msg.faqTitle02)}</h4>
          {
            msg.faqData02.map((item, index) => {
              return <FaqItem key={index} item={item} id="faq-b" index={index} />
            })
          }
          <h4 className="col-md-8 offset-md-2"><img className="faq-icon" src="images/faqup.png" alt="faq icon" />{i18n.t(msg.faqTitle03)}</h4>
          {
            msg.faqData03.map((item, index) => {
              return <FaqItem key={index} item={item} id="faq-c" index={index} />
            })
          }
          <h4 className="col-md-8 offset-md-2"><img className="faq-icon" src="images/faqup.png" alt="faq icon" />{i18n.t(msg.faqTitle04)}</h4>
          {
            msg.faqData04.map((item, index) => {
              return <FaqItem key={index} item={item} id="faq-d" index={index} />
            })
          }
          <h4 className="col-md-8 offset-md-2"><img className="faq-icon" src="images/faqup.png" alt="faq icon" />{i18n.t(msg.faqTitle05)}</h4>
          {
            msg.faqData05.map((item, index) => {
              return <FaqItem key={index} item={item} id="faq-e" index={index} />
            })
          }
        </div>
      </section>
    )
  }
}

export default Faq;